import { FC, useEffect, useState } from "react";
import { Heading, Flex, Box, Text } from "@chakra-ui/react";

import { getSchedule } from "../../services/profile";
import { days } from "../../core/constants";

interface InfoProps {
  id: string;
  providerDetails: any;
}

export const Info: FC<InfoProps> = ({ id, providerDetails }) => {
  const [schedule, setSchedule] = useState<any[]>([]);

  useEffect(() => {
    const fetchSchedule = async () => {
      setSchedule(
        await getSchedule({
          business_id: id,
          // team_member_id: id,
          timezone: "Europe/London",
          fetchMultiple: true,
        })
      );
    };

    fetchSchedule();
  }, [id]);

  return (
    <Box mt="20px">
      <Box mb="24px">
        <Heading fontSize={{ base: "18px", md: "24px" }} color={"#19202D"}>
          About
        </Heading>

        <Text fontSize={"14px"} mt="7px" color={"#4F4F51"}>
          {providerDetails?.businessDescription}
        </Text>
      </Box>

      <Box mb="24px">
        <Heading fontSize={"18px"} color={"#19202D"}>
          Availability
        </Heading>

        <Box mt="7px">
          {schedule?.map((day) => {
            const times = day.schedules.map(
              (slot: {
                start_time: string | number | Date;
                end_time: string | number | Date;
              }) => ({
                start: new Date(slot.start_time),
                end: new Date(slot.end_time),
              })
            );

            const minTime = new Date(
              Math.min(
                ...times.map((t: { start: { getTime: () => any } }) =>
                  t.start.getTime()
                )
              )
            );
            const maxTime = new Date(
              Math.max(
                ...times.map((t: { end: { getTime: () => any } }) =>
                  t.end.getTime()
                )
              )
            );

            return (
              <Flex justify={"space-between"} mb="10px" key={day.day_of_week}>
                <Text fontSize={"14px"} color={"#19202D"}>
                  {days.find((_day) => _day.id === day.day_of_week)?.name}
                </Text>

                <Box>
                  <Text fontSize={"14px"} color={"#19202D"}>
                    {minTime.toLocaleString("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                    })}{" "}
                    -{" "}
                    {maxTime.toLocaleString("en-US", {
                      hour: "numeric",
                      minute: "numeric",
                    })}
                  </Text>
                </Box>
              </Flex>
            );
          })}
        </Box>
      </Box>

      <Box mb="24px">
        <Heading fontSize={"18px"} color={"#19202D"}>
          Terms & Conditions
        </Heading>

        <Flex
          boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
          justify={"center"}
          borderRadius={"20px"}
          mt="12px"
          p="12px"
        >
          <Box
            dangerouslySetInnerHTML={{
              __html: providerDetails?.terms_and_condition,
            }}
            fontFamily={"RedHatDisplay-Regular"}
          ></Box>
        </Flex>
      </Box>
    </Box>
  );
};
